import React from "react";
import t from "module/translations";
import StickyPaper from "component/sticky/StickyPaper";
import Grid from "@mui/material/Grid";
import Typography from "@mui/material/Typography";

import CertificationAssigneeContainer from "module/certification/enrichedComponent/assigneeField/CertificationAssigneeContainer";
import CertificationModuleFieldContainer from "module/certification/enrichedComponent/moduleField/CertificationModuleFieldContainer";
import CertificationCertifierFieldContainer from "module/certification/enrichedComponent/certifierField/CertificationCertifierFieldContainer";
import CertificationExpectedDateFieldContainer from "module/certification/enrichedComponent/expectedDateField/CertificationExpectedDateFieldContainer";
import CertificationScheduledDateFieldContainer from "module/certification/enrichedComponent/scheduledDateField/CertificationScheduledDateFieldContainer";
import CertificationCompletionStartDateTimeFieldContainer from "module/certification/enrichedComponent/completionStartDateTimeField/CertificationCompletionStartDateTimeFieldContainer";
import CertificationCompletionEndDateTimeFieldContainer from "module/certification/enrichedComponent/completionEndDateTimeField/CertificationCompletionEndDateTimeFieldContainer";
import CertificationStateLabelFieldContainer from "module/certification/enrichedComponent/stateField/CertificationStateLabelFieldContainer";
import CertificationRemarksFieldContainer from "module/certification/enrichedComponent/remarksField/CertificationRemarksFieldContainer";
import CertificationNameFieldContainer from "module/certification/enrichedComponent/nameField/CertificationNameFieldContainer";

const CertificationToBeSignedDetailsOverview: React.FC = () => {
  return (
    <StickyPaper>
      <Grid container spacing={3}>
        <Grid item xs={6}>
          <CertificationNameFieldContainer />
        </Grid>
        <Grid item xs={6}>
          <CertificationAssigneeContainer />
        </Grid>
        <Grid item xs={6}>
          <CertificationModuleFieldContainer />
        </Grid>
        <Grid item xs={6}>
          <CertificationCertifierFieldContainer />
        </Grid>
      </Grid>
      <CertificationRemarksFieldContainer />
      <Typography variant="h6" gutterBottom>
        {t.competencyManagement.certification.scheduledDateHeader}
      </Typography>
      <Grid container spacing={3}>
        <Grid item xs={6}>
          <CertificationExpectedDateFieldContainer />
        </Grid>
        <Grid item xs={6}>
          <CertificationScheduledDateFieldContainer />
        </Grid>
      </Grid>
      <Typography variant="h6" gutterBottom>
        {t.competencyManagement.training.completionDateHeader}
      </Typography>
      <Grid container spacing={3}>
        <Grid item xs={6}>
          <CertificationCompletionStartDateTimeFieldContainer />
        </Grid>
        <Grid item xs={6}>
          <CertificationCompletionEndDateTimeFieldContainer />
        </Grid>
      </Grid>
      <CertificationStateLabelFieldContainer />
    </StickyPaper>
  );
};

export default React.memo(CertificationToBeSignedDetailsOverview);
